import { User } from "lucide-react";
import { BOOKMAKERS, SCAN_MARKETS } from "../valueFormat";
import { MARKET_LABEL } from "../valueFormat";
import { MARKET_NAME, gameLabel } from "./omUtils";

const tip = (g) => new Date(g.date_utc).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export function ContextPanel({ ctx, set, games, players, shots, lines }) {
  const game = games.find((g) => g.id === ctx.game);
  const roster = players.filter((p) => game && [game.home_team_id, game.away_team_id].includes(p.team_id));
  const withOdds = new Set(lines.filter((l) => l.game_id === ctx.game).map((l) => l.player_id));
  const sorted = [...roster].sort((a, b) => (withOdds.has(b.id) - withOdds.has(a.id)) || a.name.localeCompare(b.name));
  const sel = players.find((p) => p.id === ctx.player);
  const count = (m) => shots.filter((s) => ((s.game_ids || []).includes(ctx.game)) && (!ctx.book || s.bookmaker === ctx.book)
    && (s.ranges || []).some((r) => r.market === m && (!ctx.player || r.players.includes(ctx.player)))).length;
  return (
    <aside className="om-panel om-context" data-testid="om-context">
      <h3>1. SELECT CONTEXT</h3>
      <label className="om-field">Game
        <select value={ctx.game || ""} onChange={(e) => set({ ...ctx, game: e.target.value, player: "" })} data-testid="om-game-select">
          {games.map((g) => <option key={g.id} value={g.id}>{gameLabel(g)} · {tip(g)}{g.status !== "pre" ? " · started" : ""}</option>)}
        </select>
      </label>
      {game && <p className="om-game-meta" data-testid="om-game-meta">{gameLabel(game)} · {tip(game)} · {game.status === "pre" ? "Pre-game" : "Locked"}</p>}
      <label className="om-field">Player
        <select value={ctx.player || ""} onChange={(e) => set({ ...ctx, player: e.target.value })} data-testid="om-player-select">
          <option value="">All players</option>
          {sorted.map((p) => <option key={p.id} value={p.id}>{p.name} · {p.team}{withOdds.has(p.id) ? " ●" : ""}</option>)}
        </select>
      </label>
      {sel && (
        <div className="om-player-card" data-testid="om-player-card">
          {sel.photo ? <img src={sel.photo} alt={sel.name} /> : <User size={22} />}
          <div><b>{sel.name}</b><small>{sel.team}{sel.position ? ` · ${sel.position}` : ""}</small></div>
        </div>
      )}
      <label className="om-field">Bookmaker <em>(optional)</em>
        <select value={ctx.book || ""} onChange={(e) => set({ ...ctx, book: e.target.value })} data-testid="om-book-select">
          <option value="">All bookmakers</option>
          {BOOKMAKERS.map((b) => <option key={b} value={b}>{b}</option>)}
        </select>
      </label>
      <h3 className="om-h3-gap">2. SELECT MARKET</h3>
      <div className="om-market-list">
        {SCAN_MARKETS.map((m) => (
          <button key={m} type="button" className={ctx.market === m ? "is-active" : ""} onClick={() => set({ ...ctx, market: m })} data-testid={`om-market-${m}`}>
            {MARKET_NAME[m]} ({MARKET_LABEL[m]})<i data-testid={`om-market-${m}-count`}>{count(m)}</i>
          </button>
        ))}
      </div>
    </aside>
  );
}
